"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const news_1 = require("@/api/news");
const date_1 = require("@/utils/date");
const moment_1 = __importDefault(require("moment"));
let News = class News extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.data = [];
        this.totalCount = 0;
        this.currentId = "";
        this.newdetail = {};
        this.params = {
            pageNo: 1,
            pageSize: 20,
        };
    }
    getDate(date) {
        return date_1.getDateStr(date);
    }
    handleCurrentChange(val) {
        this.params.pageSize = val;
        this.getList();
    }
    newDetail(id) {
        this.currentId = id;
        news_1.newDetail({ ids: id }).then((res) => {
            res.time = moment_1.default(res.createDate).format('YYYY-MM-DD HH:mm:ss');
            this.newdetail = res;
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.keywords);
            document.querySelector('meta[name="description"]').setAttribute('content', res.description);
            document.title = res.title;
        });
    }
    getList() {
        news_1.newsList(this.params).then((res) => {
            this.data = res.list.list;
            this.totalCount = res.list.totalCount;
            // (document.querySelector('meta[name="keywords"]') as any).setAttribute(
            //   "content",
            //   res.tkd.keywords || ""
            // );
            // (document.querySelector('meta[name="description"]') as any).setAttribute(
            //   "content",
            //   res.tkd.description || ""
            // );
            // document.title = res.tkd.title || "";
        });
    }
    mounted() {
        if (this.$route.params.id == "index") {
            this.getList();
        }
        else {
            this.newDetail(this.$route.params.id);
        }
        // this.$route.params.id !== "index" && this.newDetail(this.$route.params.id);
        // this.getList();
    }
};
News = __decorate([
    vue_property_decorator_1.Component({
        components: {},
    })
], News);
exports.default = News;
